import { GridColDef } from '@mui/x-data-grid';
import { TableTooltip } from '../../../../components/general/table';
import { DateTooltip } from '../../../../components/general/dateTooltip';
import { SubtypeDPParamsHistoricalProps, fieldEquivalences } from './props';
import { ParamHistorical } from '../../../../../shared/types/param';

export const useSubtypeDPParamsHistorical = ({
    historical,
}: SubtypeDPParamsHistoricalProps) => {
    const columns: GridColDef<ParamHistorical>[] = [
        {
            field: 'fieldChange',
            headerName: 'Campo Modificado',
            minWidth: 120,
            flex: 0.4,
            sortable: false,
            renderCell: (params) => {
                return (
                    <TableTooltip
                        value={
                            params.row.elementos.field
                                ? fieldEquivalences[
                                    params.row.elementos.field
                                ] || params.row.elementos.field
                                : ''
                        }
                    />
                );
            },
        },
        {
            field: 'oldValue',
            headerName: 'Valor Anterior',
            minWidth: 120,
            flex: 0.4,
            sortable: false,
            renderCell: (params) => (
                <TableTooltip value={`${params.row.elementos.oldValue}`} />
            ),
        },
        {
            field: 'newValue',
            headerName: 'Valor Nuevo',
            minWidth: 120,
            sortable: false,
            flex: 0.4,
            renderCell: (params) => (
                <TableTooltip value={`${params.row.elementos.newValue}`} />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de modificación',
            minWidth: 100,
            sortable: false,
            flex: 0.3,
            renderCell: (params) => (
                <DateTooltip date={params.row.created_at} showFornow />
            ),
        },
        {
            field: 'createdBy',
            headerName: 'Usuario',
            minWidth: 120,
            sortable: false,
            flex: 0.4,
            renderCell: (params) => (
                <TableTooltip
                    value={
                        params.row.createdBy
                            ? `(${params.row.createdBy.username}) ${params.row.createdBy.name} ${params.row.createdBy.surname}`
                            : ''
                    }
                />
            ),
        },
    ];

    const rows =
        historical?.flatMap((row) => {
            if (row.changes) {
                const { changes, created_at, createdBy } = row;
                return changes.map((elemento, index) => {
                    changes[index].newValue = elemento.newValue;
                    changes[index].oldValue = elemento.oldValue;
                    return {
                        ...row,
                        elementos: changes[index],
                        id: row.id + index,
                        created_at,
                        createdBy,
                    };
                });
            }
            return [];
        }) || [];

    return {
        columns,
        rows: rows,
    };
};
